/**
 * Mutations for Inventory module
 * imported in store/inventory.js
 */
export default {
}
